import React from "react";
import { Link } from "react-router-dom";
import { Zap, Facebook, Twitter, Linkedin, Instagram } from "lucide-react";
import ContactModal from "./Contactus";

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300 py-6 sm:py-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-16">
        <div className="flex flex-col sm:flex-row justify-between items-center sm:items-start border-b border-gray-700 pb-4 sm:pb-6 mb-4 sm:mb-6">
          <Link to="/" className="flex flex-row items-center space-x-2 mb-4 sm:mb-0">
            <Zap className="w-6 h-6 sm:w-8 sm:h-8 text-orange-500" />
            <span className="text-xl sm:text-2xl md:text-3xl font-bold text-white">
              Resume Advisor
            </span>
          </Link>

          <div className="flex flex-wrap gap-6 sm:gap-8 text-center sm:text-left sm:flex-row">
            <div>
              <h3 className="text-md sm:text-lg font-semibold text-white mb-3 sm:mb-4">Quick Links</h3>
              <ul className="space-y-1 sm:space-y-2">
                <li>
                  <Link to="/" className="hover:text-blue-500 transition">
                    Home
                  </Link>
                </li>
                <li>
                  <Link to="/features" className="hover:text-blue-500 transition">
                    Features
                  </Link>
                </li>
                <li>
                  <Link to="/pricing" className="hover:text-blue-500 transition">
                    Pricing
                  </Link>
                </li>
                <li>
                  {/* Replace static Contact Us link with the modal trigger */}
                  <ContactModal />
                </li>
              </ul>
            </div>

            <div>
              <h3 className="text-md sm:text-lg font-semibold text-white mb-3 sm:mb-4">Contact</h3>
              <p className="text-sm">
                <span className="block">26211 Central Park Blvd, Suite 502, Southfield, MI 48076</span>
                <span className="block mt-1 sm:mt-2">Email: advisors@theresumeadvisory.com</span>
                <span className="block">Phone: 248.254.3822</span>
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Section: Social Media and Copyright */}
        <div className="flex flex-col sm:flex-row justify-between items-center">
          {/* Social Media Icons */}
          <div className="flex space-x-3 sm:space-x-4">
            <a
              href="/#"
              className="w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center bg-blue-500 rounded-full hover:bg-blue-400 transition"
              aria-label="Facebook"
            >
              <Facebook className="text-white" />
            </a>
            <a
              href="/#"
              className="w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center bg-blue-500 rounded-full hover:bg-blue-400 transition"
              aria-label="Twitter"
            >
              <Twitter className="text-white" />
            </a>
            <a
              href="/#"
              className="w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center bg-blue-500 rounded-full hover:bg-blue-400 transition"
              aria-label="Instagram"
            >
              <Instagram className="text-white" />
            </a>
            <a
              href="/#"
              className="w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center bg-blue-500 rounded-full hover:bg-blue-400 transition"
              aria-label="LinkedIn"
            >
              <Linkedin className="text-white" />
            </a>
          </div>

          <div className="mt-4 sm:mt-0 text-xs sm:text-sm text-gray-400">
            &copy; {new Date().getFullYear()} Resume Advisor. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
